import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, apiError } from "@/context/AuthContext";

export default function Login() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) nav("/", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/", { replace: true });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative overflow-hidden bg-[#0E1B2E]">
        <img
          src="https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=1200&q=80"
          alt="Boutique"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="relative z-10 h-full flex flex-col justify-between p-14 text-white">
          <div className="w-14 h-14 rounded-full bg-white/10 backdrop-blur grid place-items-center font-display text-2xl border border-white/20">AM</div>
          <div>
            <h1 className="font-display text-5xl leading-tight mb-4">Arul Mozhi<br />Store</h1>
            <p className="text-white/70 max-w-sm text-sm leading-relaxed">
              Quiet-luxury back-office for inventory, omni-channel sales, GST invoicing and
              everyday accounting. One shared stock pool, never oversold.
            </p>
          </div>
          <div className="eyebrow text-white/40">Chennai · Est. 2019</div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <div className="eyebrow mb-2">Back-office access</div>
          <h2 className="font-display text-3xl mb-8">Sign in</h2>
          <label className="label">Email</label>
          <input className="field mb-4" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required />
          <label className="label">Password</label>
          <input className="field mb-6" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required />
          <button className="btn btn-primary w-full justify-center" disabled={busy} data-testid="login-submit">
            {busy ? "Signing in…" : "Enter store"}
          </button>
        </form>
      </div>
    </div>
  );
}
